module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "full-width": "",
      "max-width": "933"
    },
    model: {
      value: (_vm.userDetalhesModal),
      callback: function($$v) {
        _vm.userDetalhesModal = $$v
      },
      expression: "userDetalhesModal"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-flex', [_c('span', {
    staticClass: "titulo-detalhes pl-4  mt-2 mb-2 headline"
  }, [_vm._v(_vm._s(_vm.user.id === '' ? 'Novo usuário' : _vm.user.nome))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.userDetalhesModal = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-form', {
    ref: "itemForm",
    attrs: {
      "name": "form-cadastro"
    }
  }, [_c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nome",
      "label": "Nome",
      "rules": _vm.rules.name,
      "value": typeof _vm.user.nome !== 'undefined' ? _vm.user.nome : '',
      "required": ""
    },
    on: {
      "input": _vm.updateName
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": "",
      "md5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Login",
      "rules": _vm.rules.login,
      "value": _vm.user.login
    },
    on: {
      "input": _vm.updateLogin
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Login utilizado para acessar o sistema.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": "",
      "md5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Senha",
      "rules": _vm.rules.password,
      "type": _vm.passwordFieldType,
      "value": _vm.user.senha
    },
    on: {
      "input": _vm.updatePassword
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.passwordFieldType == 'password'),
      expression: "passwordFieldType == 'password'"
    }],
    staticClass: "link",
    attrs: {
      "slot": "activator",
      "color": "gray"
    },
    on: {
      "click": _vm.toggleVisibility
    },
    slot: "activator"
  }, [_vm._v("visibility")]), _vm._v(" "), _c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.passwordFieldType == 'text'),
      expression: "passwordFieldType == 'text'"
    }],
    staticClass: "link",
    attrs: {
      "slot": "activator",
      "color": "gray"
    },
    on: {
      "click": _vm.toggleVisibility
    },
    slot: "activator"
  }, [_vm._v("visibility_off")]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Senha utilizado para acessar o sistema.")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "pr-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail",
      "rules": _vm.rules.email,
      "value": _vm.user.email
    },
    on: {
      "input": _vm.updateEmail
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "pl-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Telefone",
      "rules": _vm.rules.phone,
      "value": _vm.user.telefone
    },
    on: {
      "input": _vm.updatePhone
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "pr-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Departamento",
      "value": _vm.user.departamento
    },
    on: {
      "input": _vm.updateDepartment
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "pl-2": ""
    }
  }, [_c('p', [_vm._v("Ativo")]), _vm._v(" "), _c('SelectionBtn', {
    attrs: {
      "value": _vm.user.active
    },
    on: {
      "input": _vm.toggleActive
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "mt-3": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-4",
    attrs: {
      "flat": "",
      "outline": "",
      "round": "",
      "color": "green",
      "disabled": _vm.loadingItemAction
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateUser()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("done_all")]), _vm._v("Gravar")], 1)], 1)], 1), _vm._v(" "), (_vm.loadingItemAction) ? _c('v-progress-linear', {
    staticClass: "loading-modal",
    attrs: {
      "color": "error",
      "indeterminate": true
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-417dec2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/conta/usuarioDetalhe.vue
// module id = 746
// module chunks = 10